import React from 'react';
import { NavigationContent } from 'arag-ui-lib';
import ClaimCommunicatorContainer from '../containers/claimCommunicator/claimCommunicatorContainer';
import ClaimDetailsContainer from '../containers/claimDetails/claimDetailsContainer';
import { BANK_DETAILS_TAB, SURVEY_TAB, TABS } from '../utils/constants/tabs';
import ClaimBankDetailsContainer from '../containers/claimBankDetails/claimBankDetailsContainer';
import ClaimDocumentContainer from '../containers/claimDocuments/claimDocumentContainer';
import SurveyContainer from '../containers/surveyContainer/surveyContainer';

const TABS_MAPPING = {
    [TABS.communication.key]: ClaimCommunicatorContainer,
    [TABS.claimDetails.key]: ClaimDetailsContainer,
    [BANK_DETAILS_TAB.key]: ClaimBankDetailsContainer,
    [TABS.documents.key]: ClaimDocumentContainer,
    [SURVEY_TAB.key]: SurveyContainer,
};

const TabRouter = props => {
    const { activeTab, claimApplication } = props;
    const Tab = TABS_MAPPING[activeTab];

    return (
        <NavigationContent className={'tab-content--custom'}>
            <Tab claimApplication={claimApplication} />
        </NavigationContent>
    );
};

export default TabRouter;
